import { useSelector, useDispatch } from "react-redux";
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import haversine from 'haversine';
import { ModalPopUpComponent } from "../../components/modal-popup/modal-popup.component";
import { setHeader } from '../../redux/header/header.actions';
import { headerConstants } from '../../redux/header/header.constants';
import { isMobile } from 'react-device-detect';
import { vippsService } from '../../services/api/vipps.service';
import { smsService } from '../../services/api/sms.service';
import { ErrorsComponent } from '../../components/error/errors.component';
import { localStorageService } from '../../services/utilities/localStorageService';
import { sessionStorageService } from '../../services/utilities/sessionStorageService';
import { vippsStateManager } from '../../services/utilities/vippsStateManager';
import { detectMobileBrowser, getRecommendedRedirectMethod } from '../../services/utilities/browserDetector';
import { offlineDetector } from '../../services/utilities/offlineDetector';
import { logger } from '../../services/utilities/logger';
import { preLoadImagePath } from '../../helpers/images';
import { toastr } from 'react-redux-toastr';
import { AppConstant } from '../../helpers/constants';
import { errorConstants } from '../../redux/error/error.constants';
import { setAPIError } from '../../redux/error/error.actions';

function LoginComponent() {
    const [position, setPosition] = useState();
    const [locationError, setLocationError] = useState();
    const [storePosition, setStorePosition] = useState();
    const [showInputBox, setShowInputBox] = useState(false);
    const [showSendButton, setShowSendButton] = useState(false);
    const [sendButtonText, setSendButtonText] = useState('Send');
    const [sendPlaceHolderText, setSendPlaceHolderText] = useState('Skriv telefonnummer');
    const [showSMSInputBox, setShowSMSInputBox] = useState(false);
    const history = useHistory();
    const dispatch = useDispatch();
    const [devicesSelector, errorReducer] = useSelector(state => [state.deviceReducer, state.errorReducer]);
    const [mobileNo, setMobileNo] = useState();
    const [isLoader, setIsLoader] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState('');
    const [userPhoneNo, setUserPhoneNo] = useState();
    const [popUpHeaderText, setPopUpHeaderText] = useState();
    const [isOffline, setIsOffline] = useState(false);

    useEffect(() => {
        if (IsGeoLocation() && devicesSelector.deviceDetail?.goeMandatory) {
            GetLocationDetail();
        }
        
        // Set initial offline state
        setIsOffline(offlineDetector.isOffline());
        
        // Subscribe to offline/online events
        const unsubscribeOffline = offlineDetector.onOffline(() => {
            setIsOffline(true);
            toastr.warning('Ingen internettforbindelse', 'Sjekk internettforbindelsen din og prøv igjen.');
        });
        
        const unsubscribeOnline = offlineDetector.onOnline(() => {
            setIsOffline(false);
            toastr.success('Internettforbindelse gjenopprettet', 'Du kan nå fortsette.');
        });
        
        // Cleanup on unmount
        return () => {
            unsubscribeOffline();
            unsubscribeOnline();
        };
    }, [])

    const getStoreLoction = () => {
        var geoLocation = null;
        var storeCorr = devicesSelector.deviceDetail?.geoCoordinates;
        if (storeCorr != null) {
            var latLong = storeCorr.split(',');
            var corridnates = {
                latitude: latLong[0].trim(),
                longitude: latLong[1].trim(),
                distance: latLong[2].trim(),
            }
            geoLocation = {
                coords: corridnates,
            }
        }
        return geoLocation;
    }


    const IsGeoLocation = () => {
        if ("geolocation" in navigator) {
            return true;
        } else {
            return false;
        }
    }

    function report(state) {
        console.log('Permission ' + state);
    }

    const GetLocationDetail = () => {
        // Check if navigator.permissions API is available (not supported in iOS Safari < 16)
        if (navigator.permissions && navigator.permissions.query) {
            try {
                navigator.permissions.query({ name: 'geolocation' }).then(function (result) {
                    if (result.state === 'granted') {
                        report(result.state);
                        handleLocation();
                    } else if (result.state === 'prompt') {
                        report(result.state);
                        handleLocation();
                    } else if (result.state === 'denied') {
                        report(result.state);
                        if (result != null) {
                            setLocationError('Vi beklager, men det ser ut til at du har nektet å dele din nåværende posisjon. \n For å bruke denne funksjonen, må vi ha tilgang til din posisjon. Siden lastes på nytt');
                        }
                    }
                    result.onchange = function () {
                        report(result.state);
                    }
                }).catch(function (error) {
                    // If permissions API fails, fallback to direct geolocation call
                    console.warn('Permissions API failed, falling back to direct geolocation:', error);
                    handleLocation();
                });
            } catch (error) {
                // If permissions API throws, fallback to direct geolocation call
                console.warn('Permissions API error, falling back to direct geolocation:', error);
                handleLocation();
            }
        } else {
            // Fallback: Direct geolocation call if permissions API is not available
            // This works in iOS Safari < 16 and other browsers without permissions API
            console.debug('Permissions API not available, using direct geolocation call');
            handleLocation();
        }
    }

    function errorMessage(text, titleText) {
        return <ModalPopUpComponent title={titleText} message={text} />;
    }

    function handleLocation() {
        navigator.geolocation.getCurrentPosition(
            function (position) {

                if (position != null) {
                    var location = getStoreLoction();
                    setStorePosition(location);
                    setPosition(position);
                    const userLocation = { latitude: position.coords.latitude, longitude: position.coords.longitude }
                    const storeLocation = { latitude: location.coords.latitude, longitude: location.coords.longitude }
                    var distanceStore = haversine(userLocation, storeLocation);
                    if (distanceStore > 1) {
                        setPopUpHeaderText('Posisjonsdeling');
                        setLocationError('Vi beklager, men det ser ut til at du er over ' + location.coords?.distance + ' meter fra lokasjonen. Vennligst del din eksakte posisjon eller beveg deg nærmere');
                    } else {
                        distanceStore = distanceStore * 1000; // now it in meters
                        if (Number.parseFloat(location.coords?.distance) <= distanceStore) {
                            setPopUpHeaderText('Posisjonsdeling');
                            setLocationError('Vi beklager, men det ser ut til at du er over ' + location.coords?.distance + ' meter fra lokasjonen. Vennligst del din eksakte posisjon eller beveg deg nærmere');
                        }
                    }
                }
            },
            function (error) {
                if (error != null) {
                    setLocationError('Vi beklager, men det ser ut til at du har nektet å dele din nåværende posisjon. \n For å bruke denne funksjonen, må vi ha tilgang til din posisjon. Siden lastes på nytt');
                }
            }
        );
    }

    const onVippsButton = async (e) => {
        // Directly start Vipps authentication without phone number input
        if (showSMSInputBox) {
            setShowSMSInputBox(!showSMSInputBox);
            setShowSendButton(false);
        }
        
        // Start Vipps authentication directly - no phone number needed
        // Vipps will return the actual authenticated user's phone number
        await vippsDeviceInfo('', devicesSelector.deviceDetail?.deviceUUID);
    }

    const onSMSButton = (e) => {
        setShowSMSInputBox(!showSMSInputBox);
        if (showInputBox) {
            setShowInputBox(!showInputBox);
            setShowSendButton(false);
        }
        setMobileNo();
    }

    const numberChange = (value) => {
        const re = /^[0-9\b]+$/;
        if (value === '' || re.test(value)) {
            if (value.length === 8 && sendButtonText === AppConstant.sendButtonText) {
                setMobileNo(value);
                setShowSendButton(true);
            }
            else if (value.length === 4 && sendButtonText === AppConstant.sendButtonOkText) {
                setMobileNo(value);
                setShowSendButton(true);
            }
            else {
                setShowSendButton(false);
                setMobileNo(value);
            }
        }
    }

    const vippsDeviceInfo = async (phoneNo, deviceId) => {
        setIsLoader(true);
        setLoadingMessage('Kobler til Vipps...');
        
        try {
            logger.logVippsEvent('start_authentication', { phoneNo: phoneNo || 'direct (no input)', deviceId: deviceId });
            
            // Lagre DeviceUuid i sessionStorage
            try {
                sessionStorageService.setDeviceUuid(deviceId);
                logger.debug('Stored DeviceUuid in sessionStorage', { deviceId: deviceId });
            } catch (e) {
                logger.warn('Failed to store DeviceUuid in sessionStorage (non-blocking)', { error: e });
            }
            
            // Detect browser type for logging and optimization
            var browserInfo = detectMobileBrowser();
            logger.debug('Browser detected', { browserType: browserInfo.browserType, userAgent: browserInfo.userAgent });
            
            // Clean up stale sessionStorage entries
            setLoadingMessage('Forbereder innlogging...');
            vippsStateManager.cleanupStaleSessionStorage();
            
            setLoadingMessage('Starter Vipps-innlogging...');
            logger.logApiCall('POST', 'Vipps/StartAuthentication', { phoneNo: phoneNo || '', deviceId: deviceId });
            var data = await vippsService.mobileNoAndDeviceID(phoneNo, deviceId);
            logger.logApiResponse('POST', 'Vipps/StartAuthentication', data ? 200 : 500, { hasLoginURL: !!data?.loginURL });
            
            if (data !== null && typeof (data) !== 'string') {
                var endPoint = data.loginURL;
                if (endPoint) {
                    logger.logVippsEvent('redirect_to_vipps', { deviceId: deviceId });
                    // Extract state parameter from loginURL and store it
                    var stateString = vippsStateManager.extractStateFromLoginURL(endPoint);
                    if (stateString) {
                        var stateData = vippsStateManager.parseState(stateString);
                        if (stateData && stateData.deviceUuid) {
                            // Store state for validation on callback
                            vippsStateManager.storeState(stateData.deviceUuid, {
                                state: stateString,
                                timestamp: stateData.timestamp,
                                nonce: stateData.nonce,
                                createdAt: Date.now()
                            });
                            
                            // Generate and store auth token
                            var authToken = vippsStateManager.generateAuthToken();
                            vippsStateManager.storeAuthToken(authToken);
                        }
                    }
                    
                    // Store redirect timestamp for timeout detection
                    sessionStorageService.setRedirectTime(Date.now().toString());
                    sessionStorageService.setRedirectBrowser(browserInfo.browserType);
                    
                    // Show redirect message
                    setLoadingMessage('Omdirigerer til Vipps...');
                    
                    // Try to open Vipps app directly using deep linking / Android Intent
                    // This skips the intermediate "Åpne vipps" button on api.vipps.no
                    try {
                        var isAndroid = /Android/i.test(navigator.userAgent);
                        
                        if (isAndroid) {
                            // Android: Use Intent URL to open Vipps app directly
                            // Format: intent://[path]#Intent;scheme=vipps;package=no.dnb.vipps;end
                            try {
                                // Extract path and query from OAuth URL
                                var url = new URL(endPoint);
                                var pathAndQuery = url.pathname + url.search;
                                
                                // Construct Android Intent URL
                                var intentUrl = 'intent://' + pathAndQuery.replace(/^\//, '') + '#Intent;' +
                                    'scheme=vipps;' +
                                    'package=no.dnb.vipps;' +
                                    'S.browser_fallback_url=' + encodeURIComponent(endPoint) + ';' +
                                    'end';
                                
                                logger.logVippsEvent('android_intent_redirect', { deviceId: deviceId, intentUrl: intentUrl });
                                
                                // Try to open via Intent (opens app directly if installed)
                                // If app is not installed, Android will fall back to browser_fallback_url
                                window.location.href = intentUrl;
                            } catch (intentError) {
                                logger.warn('Failed to create Android Intent URL, falling back to HTTP redirect', { error: intentError });
                                // Fallback to HTTP redirect
                                window.location.href = endPoint;
                            }
                        } else {
                            // iOS or other: Try direct vipps:// deep link
                            try {
                                var vippsDeepLink = endPoint.replace(/^https?:\/\/api\.vipps\.no/, 'vipps://');
                                
                                logger.logVippsEvent('ios_deep_link_redirect', { deviceId: deviceId, deepLink: vippsDeepLink });
                                
                                // Try deep link with timeout fallback
                                var timeout = setTimeout(function() {
                                    logger.debug('Deep link timeout, falling back to HTTP redirect');
                                    window.location.href = endPoint;
                                }, 500);
                                
                                window.location.href = vippsDeepLink;
                                
                                // Clear timeout if deep link works (though we may not reach here)
                                clearTimeout(timeout);
                            } catch (deepLinkError) {
                                logger.warn('Failed to create deep link, falling back to HTTP redirect', { error: deepLinkError });
                                // Fallback to HTTP redirect
                                window.location.href = endPoint;
                            }
                        }
                    } catch (redirectError) {
                        logger.error('Error in redirect handling, using HTTP fallback', { error: redirectError });
                        // Final fallback to HTTP redirect
                        try {
                            window.location.href = endPoint;
                        } catch (fallbackError) {
                            logger.error('All redirect methods failed', { error: fallbackError });
                            toastr.error('Kunne ikke omdirigere til Vipps. Vennligst prøv igjen.');
                        }
                    }
                    
                    var userInfo = {
                        loginType: AppConstant.vippsAppName,
                        pageType: AppConstant.success,
                        message: ''
                    }
                    // Only store phone number if it was provided (for SMS fallback scenarios)
                    if (phoneNo) {
                        localStorageService.setVippsMobileNo(phoneNo);
                    }
                    dispatch(setHeader(headerConstants.SET_HEADER, true, userInfo));
                }
            }
        } catch (error) {
            logger.error('Error in vippsDeviceInfo', error, { phoneNo: phoneNo || 'direct (no input)', deviceId: deviceId });
            toastr.error('En feil oppstod ved start av Vipps-innlogging. Vennligst prøv igjen.');
            setLoadingMessage('');
        } finally {
            setIsLoader(false);
        }
    }

    const smsDevice = async (phoneNo, deviceId) => {
        setIsLoader(true);
        setLoadingMessage('Sender SMS-kode...');
        var data = await smsService.mobileNoAndDeviceID(phoneNo, deviceId);
        if (data !== null) {
            if (data.status) {
                setUserPhoneNo(phoneNo);
                setShowSendButton(false);
                setSendButtonText(AppConstant.sendButtonOkText);
                setMobileNo('');
                setSendPlaceHolderText('Skriv kode');
                setLoadingMessage('');
            } else {
                // Check if it's a timeout error (400)
                var isTimeout = data && data.error === 'timeout';
                dispatch(setAPIError(errorConstants.SET_ERROR_API, true, true, isTimeout ? 400 : null));
                setLoadingMessage('');
            }
        }

        setIsLoader(false);
    }

    const smsVerifyOtp = async (Otp, deviceId) => {
        const isValid = Otp.length === 4;
        setIsLoader(true);
        setLoadingMessage('Verifiserer kode...');
        if (isValid) {
            var data = await smsService.verifyOTP(Otp, userPhoneNo, deviceId);
            if (data !== null) {
                if (data.status !== undefined) {
                    var userInfo = {
                        loginType: AppConstant.smsName,
                        pageType: data.status === true ? AppConstant.success : AppConstant.error,
                        message: data.status === true ? "" : data.errorMessage,
                        contact: data.contact,
                        device_instruction: data.device_instruction,
                        contact_instruction: data.contact_instruction
                    }
                }
                dispatch(setHeader(headerConstants.SET_HEADER, true, userInfo));
                setLoadingMessage('');
                history.push("/home");
            }
        }
        else {
            toastr.info("Koden du tastet inn er dessverre ikke gyldig. Hent ny kode ved å trykke på 'Lås opp med mobil' og prøv på nytt.");
            setLoadingMessage('');
        }
        setIsLoader(false);
    }

    const onSendButton = (typeName) => {
        // Check if offline before proceeding
        if (isOffline || offlineDetector.isOffline()) {
            toastr.error('Ingen internettforbindelse', 'Sjekk internettforbindelsen din og prøv igjen.');
            return;
        }
        
        if (typeName === AppConstant.vippsAppName) {
            if (isMobile) {
                vippsDeviceInfo(mobileNo, devicesSelector.deviceDetail?.deviceUUID);
            } else {
                toastr.info("Støtter ikke på skrivebordet. Vennligst bruk mobiltelefon.");
            }
        } else {
            if (isMobile) {
                if (sendButtonText === AppConstant.sendButtonText && devicesSelector.deviceDetail?.isSMS === true) {
                    smsDevice(mobileNo, devicesSelector.deviceDetail?.deviceUUID);
                }
                else if (sendButtonText === AppConstant.sendButtonOkText) {
                    smsVerifyOtp(mobileNo, devicesSelector.deviceDetail?.deviceUUID);
                }
            } else {
                toastr.info("Støtter ikke på skrivebordet. Vennligst bruk mobiltelefon.");
            }
        }
    }

    const inputBox = (typeName) => {
        var cssClass = "button-group-orange";
        var sendCssClass = "d-inline-block btn";
        if (typeName === AppConstant.vippsAppName) {
            sendCssClass += " primary-btn text-white";
        } else {
            cssClass = "button-group-blue";
            sendCssClass += " btn-primary";
        }
        cssClass = "button-group " + cssClass;

        return (<div className={cssClass}>
            <input ref={(input) => { input && input.focus() }} value={(mobileNo !== 0 || typeName === AppConstant.vippsAppName) ? mobileNo : ''} placeholder={sendPlaceHolderText} className="dx-theme-background-color inputText dx-theme-border-color" type="number" onChange={e => numberChange(e.target.value)} disabled={isOffline} />
            {
                showSendButton
                    ?
                    <button type="button" disabled={isLoader || isOffline} id="custom-btn-login" className={sendCssClass} onClick={() => onSendButton(typeName)}>
                        {sendButtonText}
                    </button>
                    :
                    ''
            }
            {isOffline && (
                <p className="text-warning small mt-2 text-center">Ingen internettforbindelse</p>
            )}
        </div>);
    }

    const renderComponent = () => {
        return (<div className="d-flex align-item-center justify-content-start flex-direction-colomn h-100">

            {locationError != null ? errorMessage(locationError, popUpHeaderText) : ''}

            <div className="d-flex align-item-center flex-direction-colomn w-100">
                <h1 className="mr-5">Lås opp</h1>
                <h1>&nbsp;&nbsp;&nbsp; med <span className="orange-vipps"> vipps </span> </h1>
                <p className="font-weight-bold">En tjeneste levert av Touch Soft AS</p>
            </div>

            <div className="d-flex justify-content-between flex-direction-colomn w-100" style={{ marginTop: '3vh' }}>

                <div className="d-flex flex-direction-colomn">
                    {showInputBox ?
                        inputBox(AppConstant.vippsAppName)
                        :
                        <button type="button" className="btn primary-btn custom-btn text-white btn-lg btn-block" onClick={onVippsButton}>
                            <svg width="25" height="25" viewBox="0 0 23 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19.75 10.5H18.375V7.75C18.375 3.955 15.295 0.875 11.5 0.875C7.705 0.875 4.625 3.955 4.625 7.75V10.5H3.25C1.7375 10.5 0.5 11.7375 0.5 13.25V27C0.5 28.5125 1.7375 29.75 3.25 29.75H19.75C21.2625 29.75 22.5 28.5125 22.5 27V13.25C22.5 11.7375 21.2625 10.5 19.75 10.5ZM11.5 22.875C9.9875 22.875 8.75 21.6375 8.75 20.125C8.75 18.6125 9.9875 17.375 11.5 17.375C13.0125 17.375 14.25 18.6125 14.25 20.125C14.25 21.6375 13.0125 22.875 11.5 22.875ZM15.7625 10.5H7.2375V7.75C7.2375 5.39875 9.14875 3.4875 11.5 3.4875C13.8512 3.4875 15.7625 5.39875 15.7625 7.75V10.5Z" fill="white" />
                            </svg> &nbsp;&nbsp;
                            Lås opp med <strong> vipps</strong>
                        </button>
                    }
                    <br />
                    <span id="altsmscodetxt" className={`mb-2 text-center ${!devicesSelector.deviceDetail?.isSMS ? 'hide' : ''}`}>Har du <i>ikke</i> Vipps? Lås opp med mobil. </span>


                    {showSMSInputBox ?
                        inputBox(AppConstant.smsName)
                        :
                        <button type="button" disabled={!devicesSelector.deviceDetail?.isSMS} className={`btn btn-primary custom-btn btn-lg btn-block ${!devicesSelector.deviceDetail?.isSMS ? 'hide' : ''}`} onClick={onSMSButton}>
                            <svg width="25" height="25" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M25 0.25H3C1.4875 0.25 0.26375 1.4875 0.26375 3L0.25 27.75L5.75 22.25H25C26.5125 22.25 27.75 21.0125 27.75 19.5V3C27.75 1.4875 26.5125 0.25 25 0.25ZM9.875 12.625H7.125V9.875H9.875V12.625ZM15.375 12.625H12.625V9.875H15.375V12.625ZM20.875 12.625H18.125V9.875H20.875V12.625Z" fill="white" />
                            </svg> &nbsp;&nbsp;
                            Lås opp med <strong> mobil</strong>
                        </button>
                    }
                </div>
            </div>
        </div>);
    }

    return (
        <>
            <div id="warpper-body" className="wrapper-rounded-login">
                {
                    isLoader ?
                        <div className="d-flex align-item-center flex-direction-colomn loadingCircle">
                            <img src={`${preLoadImagePath.loader}`} width="45" alt="cutomer_loader_orange" />
                            {loadingMessage && (
                                <p className="mt-3 text-center text-white">{loadingMessage}</p>
                            )}
                        </div>
                        :
                        ''
                }
                {(errorReducer.name === errorConstants.SET_ERROR || errorReducer.name === errorConstants.SET_ERROR_API) && errorReducer.isActive === true ? <ErrorsComponent /> : renderComponent()}

            </div>
        </>
    );
}

export { LoginComponent };